import API from 'services/api.js';
import { URL_GET_WEIGHT_DISTRIBUTION } from 'services/urls.js';

export type WeightHistogram = { [bin: string]: number };
export type WeightDistributionData = {
	weightType: string;
	units: string;
	binSize: number;
	five: WeightHistogram;
	ten: WeightHistogram;
	all: WeightHistogram;
};

export const actionFetchWeightDistributionData = (
	sessionId: number,
	setLoading: (l: boolean) => void,
	showMessage: (msg: string) => void,
	format = 'c3'
): Promise<WeightDistributionData[]> => {
	const params = {
		params: {
			sessionId: sessionId,
		},
		headers: {
			'x-opw-format': format,
		},
	};
	console.log('params', params);
	return API.get(URL_GET_WEIGHT_DISTRIBUTION, params)
		.then((response) => {
			console.log('actionFetchWeightDistributionData() response', response);
			return response.data;
		})
		.catch((error) => {
			showMessage('Err fetching distribution by week data: ' + error);
			return [];
		})
		.then((resp) => {
			setLoading(false);
			return resp;
		});
};
